import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { Heart, CreditCard, Banknote, Users, BookOpen, Globe, Mail, Smartphone } from "lucide-react";
import { useState } from "react";
import paypalQR from "@/assets/payments/paypal-qr.jpg";
import zelleQR from "@/assets/payments/zelle-qr.png";

const Give = () => {
  const [selectedAmount, setSelectedAmount] = useState<string>("");
  const [customAmount, setCustomAmount] = useState<string>("");
  const [donationType, setDonationType] = useState<string>("one-time");
  const [designation, setDesignation] = useState<string>("general");
  const [notes, setNotes] = useState<string>("");

  const impactAreas = [
    {
      icon: BookOpen,
      title: "Support UESI Ministry",
      description:
        "Partner with us in sustaining the ongoing activities of UESI—Bible studies, discipleship programs, campus outreach, and leadership development—equipping students to grow in faith and witness.",
    },
    {
      icon: Users,
      title: "Support Conference Expenses",
      description:
        "Help cover the costs of organizing and running our conferences, including venue, materials, travel, and hospitality, so that students and staff can attend without financial burden.",
    },
    {
      icon: Globe,
      title: "Support OFUESI Outreach",
      description:
        "Enable us to extend the ministry of OFUESI beyond our current region by supporting travel, training, and seed efforts to strengthen fellowships and plant student ministries in new states.",
    },
  ];

  const givingOptions = [
    {
      title: "One-Time Donation",
      description: "Make a single contribution to support OFUESI ministries",
      icon: Heart,
      buttonText: "Give Now",
    },
    {
      title: "Monthly Partnership",
      description: "Become a monthly partner and provide sustained support",
      icon: CreditCard,
      buttonText: "Become a Partner",
    },
    {
      title: "Legacy Giving",
      description: "Learn about planned giving and leaving a lasting impact",
      icon: Banknote,
      buttonText: "Learn More",
    },
  ];

  return (
    <div className="min-h-screen bg-background">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-ministry-cyan via-primary to-ministry-cyan py-10 relative">
        <div className="absolute inset-0 faith-pattern opacity-20"></div>
        <div className="container mx-auto px-4 text-center relative z-10">
          <div className="max-w-4xl mx-auto text-white space-y-6">
            <h1 className="text-4xl lg:text-6xl font-bold">Partner With Us</h1>
            <p className="text-xl text-blue-100 leading-relaxed">
              Your generous giving enables us to reach students across universities nationwide and support the ministry
              of UESI in India.
            </p>
          </div>
        </div>
      </section>

      {/* Donation Form 
      <section className="py-8">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto">
            <Card>
              <CardHeader className="text-center">
                <CardTitle className="text-2xl">Make a Donation</CardTitle>
                <p className="text-muted-foreground">
                  Your support makes student ministry possible
                </p>
              </CardHeader>
              <CardContent className="space-y-6">
                <div>
                  <label className="block text-sm font-medium mb-2">Donation Amount</label>
                  <div className="grid grid-cols-4 gap-2 mb-4">
                    {['$25', '$50', '$100', '$250'].map((amount) => (
                      <Button 
                        key={amount} 
                        variant={selectedAmount === amount ? "default" : "outline"} 
                        className="w-full"
                        onClick={() => {
                          setSelectedAmount(amount);
                          setCustomAmount("");
                        }}
                      >
                        {amount}
                      </Button>
                    ))}
                  </div>
                  <div className="flex">
                    <span className="inline-flex items-center px-3 text-sm text-muted-foreground bg-muted border border-r-0 border-input rounded-l-md">
                      $
                    </span>
                    <input
                      type="number"
                      placeholder="Other amount"
                      value={customAmount}
                      onChange={(e) => {
                        setCustomAmount(e.target.value);
                        setSelectedAmount("");
                      }}
                      className="flex h-10 w-full rounded-r-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium mb-2">Donation Type</label>
                  <div className="grid grid-cols-2 gap-2">
                    <Button 
                      variant={donationType === "one-time" ? "default" : "outline"}
                      onClick={() => setDonationType("one-time")}
                    >
                      One-Time
                    </Button>
                    <Button 
                      variant={donationType === "monthly" ? "default" : "outline"}
                      onClick={() => setDonationType("monthly")}
                    >
                      Monthly
                    </Button>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium mb-2">Designate Gift (Optional)</label>
                  <select 
                    value={designation} 
                    onChange={(e) => setDesignation(e.target.value)}
                    className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
                  >
                    <option value="general">Where needed most</option>
                    <option value="scholarships">Student Scholarships</option>
                    <option value="campus">Campus Ministry</option>
                    <option value="international">International Outreach</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium mb-2">Notes (Optional)</label>
                  <textarea
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    placeholder="Add any special instructions or notes for your donation..."
                    rows={3}
                    className="flex w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 resize-none"
                  />
                </div>

                <Button className="w-full bg-gradient-to-br from-ministry-cyan via-primary to-ministry-cyan" size="lg">
                  Continue to Payment
                </Button>

                <p className="text-xs text-muted-foreground text-center">
                  Your donation is secure and tax-deductible. OFUESI is a registered 501(c)(3) organization.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
      */}
      {/* Payment Methods */}
      <section className="py-8">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-4">Payment Methods</h2>
            <p className="text-lg text-muted-foreground">
              If you'd like to contribute financially to OFUESI, through other payment methods you can do it by mail or
              Zelle.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {/* PayPal */}
            <Card className="elegant-shadow">
              <CardHeader className="text-center">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <CreditCard className="w-6 h-6 text-primary" />
                </div>
                <CardTitle>PayPal</CardTitle>
              </CardHeader>
              <CardContent className="space-y-3">
                <p className="text-sm text-muted-foreground text-center">Donate securely using PayPal:</p>
                <div className="flex justify-center">
                  <form action="https://www.paypal.com/donate" method="post" target="_top">
                    <input type="hidden" name="hosted_button_id" value="S28LMMVUKUU2N" />
                    <input
                      type="image"
                      src="https://www.paypalobjects.com/en_US/i/btn/btn_donate_LG.gif"
                      name="submit"
                      title="PayPal - The safer, easier way to pay online!"
                      alt="Donate with PayPal button"
                      className="hover:opacity-90 transition-opacity"
                    />
                    <img alt="" src="https://www.paypal.com/en_US/i/scr/pixel.gif" width="3" height="3" />
                  </form>
                </div>
                <div className="flex flex-col items-center mt-4">
                  <img 
                    src={paypalQR}
                    alt="PayPal QR Code"
                    className="w-48 h-48 object-contain rounded-lg border border-border/50"
                    loading="lazy"
                  />
                  <p className="text-xs text-center text-muted-foreground mt-2">Scan to give via PayPal</p>
                </div>
              </CardContent>
            </Card>
            {/* By Mail */}
            <Card>
              <CardHeader className="text-center">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Mail className="w-6 h-6 text-primary" />
                </div>
                <CardTitle>By Mail</CardTitle>
              </CardHeader>
              <CardContent className="space-y-3">
                <p className="text-sm text-muted-foreground">Please make checks payable to OFUESI and mail them to:</p>
                <div className="text-sm">
                  <div className="font-medium">OFUESI Treasurer</div>
                  <div>11455 Oleander Dr. Frisco, TX 75035</div>
                  <div className="mt-2">
                    <span className="text-muted-foreground">Email: </span>
                    <a href="mailto:ofuesi.treasurer@gmail.com" className="text-primary hover:underline">
                      ofuesi.treasurer@gmail.com
                    </a>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* ZELLE */}
            <Card>
              <CardHeader className="text-center">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Smartphone className="w-6 h-6 text-primary" />
                </div>
                <CardTitle>ZELLE</CardTitle>
              </CardHeader>
              <CardContent className="space-y-3">
                <p className="text-sm text-muted-foreground">Send money using ZELLE with the following ID:</p>
                <div className="text-center p-3 bg-secondary/30 rounded-md">
                  <div className="font-medium text-sm">ofuesi.treasurer@gmail.com</div>
                </div>
                <div className="flex flex-col items-center mt-4">
                  <img 
                    src={zelleQR}
                    alt="Zelle QR Code"
                    className="w-48 h-48 object-contain rounded-lg border border-border/50"
                    loading="lazy"
                  />
                  <p className="text-xs text-center text-muted-foreground mt-2">Scan to give via Zelle</p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Impact Areas */}
      <section className="py-8">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-4">Where Your Giving Makes Impact</h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Every donation directly supports student ministry and discipleship programs
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {impactAreas.map((area, index) => (
              <Card key={index} className="text-center hover:shadow-lg transition-shadow">
                <CardHeader>
                  <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center mx-auto mb-4">
                    <area.icon className="w-8 h-8 text-white" />
                  </div>
                  <CardTitle>{area.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground mb-4">{area.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Give;
